import { useEffect, useRef } from 'react'

import { playSound, playSoundUntilFinished } from '@/src/utils/soundPlayer'
import {
    playCharacterConfigSound,
} from './characterMovementSound'

export function playButtonPrimarySound(): void {
    playSound('buttonPrimary')
}

export function playButtonSecondarySound(): void {
    playSound('buttonSecondary')
}

export function playButtonDiceSound(): void {
    playSoundUntilFinished('buttonDice').then(() => {
        playCharacterConfigSound()
    })
}

export function playShortWooshSound(): void {
    playSound('shortWoosh')
}

export function playLongWooshSound(): void {
    playSound('longWoosh')
}

export function playChangeConfigValueSound(): void {
    playSoundUntilFinished('changeColor').then(() => {
        playCharacterConfigSound()
    })
}

export function playUpgradeSound(): void {
    playSound('upgrade')
}

const FINAL_UPGRADE_COUNT = 4

export function playUpgradeSoundSequence(unlockedCount: number): void {
    void playSoundUntilFinished('upgrade').then(() => {
        playSound(unlockedCount >= FINAL_UPGRADE_COUNT ? 'characterUpgradeFinal' : 'characterUpgrade')
    })
}

export function playCountdownSound(): void {
    playSound('countdown')
}

export function playPopupOpenSound(): void {
    playSound('popupOpen')
}

export function playPopupCloseSound(): void {
    playSound('popupClose')
}

export function withPopupCloseSound(onClose?: () => void) {
    return () => {
        playPopupCloseSound()
        onClose?.()
    }
}

// Plays long-woosh once when `active` transitions from false to true
export function useHintWooshSound(active: boolean): void {
    const wasActiveRef = useRef(false)

    useEffect(() => {
        if (active && !wasActiveRef.current) {
            playLongWooshSound()
        }
        wasActiveRef.current = active
    }, [active])
}

// Plays short-woosh once when the component mounts (title / logo slide-in)
export function useSlideInWooshSound(enabled = true): void {
    const hasPlayedRef = useRef(false)

    useEffect(() => {
        if (!enabled || hasPlayedRef.current) {
            return
        }

        hasPlayedRef.current = true
        playShortWooshSound()
    }, [enabled])
}

// Plays short-woosh when `active` transitions from false to true
export function useSlideInWooshOnActive(active: boolean): void {
    const wasActiveRef = useRef(false)

    useEffect(() => {
        if (active && !wasActiveRef.current) {
            playShortWooshSound()
        }
        wasActiveRef.current = active
    }, [active])
}
